import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Modal, Form, Slider, Button, InputNumber, message, Popconfirm } from "antd";
import restaurantSchemaActions from "../../../redux/restaurantSchema/actions";
import CloseButton from "../../Common/CloseButton/CloseButton";
import "./index.css";

const { editReservationTable, deleteReservationTable } =
  restaurantSchemaActions;

const SHAPE_OPTIONS = [
  { label: "Кръгла", value: 1, cssClass: "round" },
  { label: "Квадратна", value: 2, cssClass: "square" },
  { label: "Правоъгълна", value: 3, cssClass: "rect" },
];

const EditTableModal = ({
  openEditTableModal,
  setOpenEditTableModal,
  clickedTable,
  setClickedTable,
}) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [selectedShape, setSelectedShape] = useState(null);
  const [seatsCount, setSeatsCount] = useState(null);

  const scaleMarks = {
    0.6: "Малка",
    1.0: "Средна",
    1.5: "Голяма",
    2.0: "XL",
  };

  const isObject = clickedTable?.[0]?.shape >= 4;

  const handleEditTable = () => {
    form.validateFields().then((values) => {
      if (isObject) {
        dispatch(
          editReservationTable({
            x: clickedTable[0].x,
            y: clickedTable[0].y,
            direction: clickedTable[0].direction,
            scale: values.scale ?? clickedTable[0]?.scale ?? 1.0,
            shape: clickedTable[0].shape,
            seatsCount: clickedTable[0].seatsCount,
            tableName: clickedTable[0].tableName,
            organizationId: parseInt(localStorage.getItem("organizationId")),
            touchSaleTableId: clickedTable[0].touchSaleTableId,
            regionId: clickedTable[0].regionId,
          })
        );
      } else {
        if (!selectedShape) {
          message.warning("Моля изберете форма на масата");
          return;
        }
        if (!seatsCount || seatsCount < 1) {
          message.warning("Моля въведете брой места");
          return;
        }
        dispatch(
          editReservationTable({
            x: clickedTable[0].x,
            y: clickedTable[0].y,
            direction: clickedTable[0].direction,
            scale: values.scale ?? clickedTable[0]?.scale ?? 1.0,
            shape: selectedShape,
            seatsCount: seatsCount,
            tableName: clickedTable[0].tableName,
            organizationId: parseInt(localStorage.getItem("organizationId")),
            touchSaleTableId: clickedTable[0].touchSaleTableId,
            regionId: clickedTable[0].regionId,
          })
        );
      }

      setClickedTable([]);
      setSelectedShape(null);
      setSeatsCount(null);
      setOpenEditTableModal(false);
      message.success("Успешно запазени промени");
      form.resetFields();
    });
  };

  const handleDeleteTable = (e) => {
    dispatch(
      deleteReservationTable({
        organizationId: parseInt(localStorage.getItem("organizationId")),
        touchSaleTableId: clickedTable[0].touchSaleTableId,
        tableName: clickedTable[0].tableName,
        regionId: clickedTable[0].regionId,
      })
    );
    setOpenEditTableModal(false);
    message.success(isObject ? "Успешно изтриване на обект" : "Успешно изтриване на маса");
    form.resetFields();
  };

  useEffect(() => {
    if (clickedTable && clickedTable.length !== 0) {
      setSelectedShape(clickedTable[0]?.shape < 4 ? clickedTable[0]?.shape : null);
      setSeatsCount(clickedTable[0]?.seatsCount || null);
      form.setFieldsValue({
        scale: clickedTable[0]?.scale || 1.0,
      });
    }
  }, [clickedTable, form]);

  return (
    <Modal
      closeIcon={<CloseButton />}
      title={isObject ? `Промени обект (${clickedTable?.[0]?.tableName || ""})` : `Промени Маса (${clickedTable?.[0]?.tableName || ""}) - ${clickedTable?.[0]?.seatsCount || 0} места`}
      open={openEditTableModal}
      onOk={handleEditTable}
      onCancel={() => {
        setOpenEditTableModal(false);
        setClickedTable([]);
        setSelectedShape(null);
        setSeatsCount(null);
        form.resetFields();
      }}
      footer={null}
      className="restaurant-scheme-table-modal"
    >
      {!isObject && (
        <>
          <div className="create-modal-shape-label">Форма на масата</div>
          <div className="create-modal-shape-grid">
            {SHAPE_OPTIONS.map((s) => (
              <div
                key={s.value}
                className={`create-modal-shape-card ${selectedShape === s.value ? "selected" : ""}`}
                onClick={() => setSelectedShape(s.value)}
              >
                <div className="create-modal-shape-card-preview">
                  <div
                    className={`create-modal-shape-preview ${s.cssClass}`}
                    style={{
                      width: s.cssClass === "rect" ? 52 : 36,
                      height: 36,
                    }}
                  >
                    {seatsCount && selectedShape === s.value ? (
                      <span className="create-modal-shape-preview-seats">
                        {seatsCount}
                      </span>
                    ) : null}
                  </div>
                </div>
                <span className="create-modal-shape-card-name">{s.label}</span>
              </div>
            ))}
          </div>

          <div className="create-modal-shape-label">Брой места</div>
          <InputNumber
            min={1}
            max={30}
            value={seatsCount}
            onChange={(val) => setSeatsCount(val)}
            placeholder="Брой места"
            style={{ width: "100%", marginBottom: 16 }}
          />
        </>
      )}
      <Form form={form} layout="vertical">
        <Form.Item
          name="scale"
          label="Размер на масата"
        >
          <Slider
            min={0.6}
            max={2.0}
            step={0.1}
            marks={scaleMarks}
            tooltip={{ formatter: (val) => `${Math.round(val * 100)}%` }}
          />
        </Form.Item>
      </Form>
      <div className="restaurant-scheme-edit-table-modal-footer">
        <Popconfirm
          title={isObject ? "Изтриване на обект" : "Изтриване на маса"}
          description={isObject ? "Сигурни, че искате да изтриете този обект?" : "Сигурни, че искате да изтриете тази маса?"}
          onConfirm={handleDeleteTable}
          placement="bottom"
          okText="Изтрий"
          cancelText="Назад"
        >
          <Button danger>{isObject ? "Изтрий обект" : "Изтрий маса"}</Button>
        </Popconfirm>
        <Button type="primary" onClick={handleEditTable}>
          Промени
        </Button>
      </div>
    </Modal>
  );
};

export default EditTableModal;
